import React, {Component} from 'react';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {Card, Header, Form, Button, Select} from 'semantic-ui-react';
import {reverseShortDate, dateFormatPicker} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {dealerListForForcastSale} from '../../../common/constants/lists';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import Loader from '../../../common/components/loader';
import {downloadFile} from '../../../common/util/file';
import ExcelIcon from '../icons/Excelcon';
import InvoiceTable from './Table';
import './styles.scss';

class InvoicesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'start': null,
      'end': null,
      'dealer': '',
      'optionsDealer': [],
    };
    this.handleSearch = this.handleSearch.bind(this);
  }
  
  componentDidMount() {
    const {isUserFromTDE, dealerId} = this.props;
    if (!hasAccessPermission(this.props.permissions, resources.InvoicesList, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    const optionsDealer = isUserFromTDE ?
      dealerListForForcastSale : dealerListForForcastSale.filter((item) => item.value === dealerId);
    const dealer = isUserFromTDE ? 'all' : optionsDealer[0].value;
    this.setState({
      optionsDealer,
      dealer,
    });
    this.props.clearInvoicesListDownload();
  }

  componentWillUnmount() {
    this.props.clearInvoicesListDownload();
  }

  handleChange(field, value) {
    this.setState({[field]: value});
  }

  handleSearch() {
    const {start, end, dealer} = this.state;
    const {searchScope, dealerAgency} = this.props;
    if (start && end) {
      const startDate = moment(start).format(reverseShortDate);
      const endDate = moment(end).format(reverseShortDate);
      this.props.getInvoicesListDownload(startDate, endDate, {dealer, searchScope, dealerAgency});
    } else {
      this.props.addMessageBoxError('Es necesario los 2 valores de búsqueda');
    }
  }

  handleDowloadDocument(url) {
    downloadFile(url);
    return null;
  }

  render() {
    const {start, end, dealer, optionsDealer} = this.state;
    const {loading, excel, list, isUserFromTDE} = this.props;

    if (loading) {
      return <Loader/>;
    }
    
    return (
      <div>
        <Card raised fluid>
          <div className="invoices-list-container">
            <Header as="h2" align="left">Listado de Facturas</Header>
          </div>
          <Form>
            <div className="invoices-list-container-controls">
              <Form.Group widths='twelve'>
                <Form.Input label="Fecha Inicial" className="invoice-list-label">
                  <DatePicker
                    locale='es'
                    placeholderText='Fecha de inicio'
                    className="tcc-datepicker"
                    showYearDropdown
                    selected={start}
                    maxDate={moment().toDate()}
                    dateFormat={dateFormatPicker}
                    onChange={(value) => this.handleChange('start', value)}
                  />
                </Form.Input >
                <Form.Input label="Fecha Final" className="invoice-list-label" >
                  <DatePicker
                    locale='es'
                    placeholderText='Fecha final'
                    className="tcc-datepicker"
                    showYearDropdown
                    selected={end}
                    minDate={start}
                    maxDate={moment().toDate()}
                    dateFormat={dateFormatPicker}
                    onChange={(value) => this.handleChange('end', value)}
                  />
                </Form.Input>
                <Form.Field
                  className="invoice-list-label invoice-list-select"
                  control={Select}
                  options={optionsDealer}
                  label='Concesionario'
                  placeholder='Concesionario'
                  value={dealer}
                  onChange={(e, {value}) => this.handleChange('dealer', value)}
                />
                <div className="ml-2 invoice-list-btn">
                  <Button onClick={this.handleSearch} type="submit" color="black">BUSCAR</Button>
                </div>
              </Form.Group>
              {list.length > 0 &&
                <div className="invoice-lis-icons">
                  <div className="pointer" onClick={() => this.handleDowloadDocument(excel)}>
                    <ExcelIcon/>
                  </div>
                </div>
              }
            </div>
          </Form>
        </Card>
        <Card raised fluid>
          <InvoiceTable dataTable={list} isUserFromTDE={isUserFromTDE}/>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {isUserFromTDE, dealerId, permissions, dealerAgency} = state.session;
  const permission = permissions.find((item) => item.rsname === 'Listado de Facturas');
  let searchScope = false;
  if (permission) {
    searchScope = permission.scopes.includes(scopes.PartialSee);
  }

  return {
    'permissions': state.session.permissions,
    'loading': state.invoicesListDownload.loading,
    'list': state.invoicesListDownload.list,
    'excel': state.invoicesListDownload.excel,
    isUserFromTDE,
    dealerId,
    'searchScope': searchScope || isUserFromTDE ? 'allAgencies' : 'agency',
    dealerAgency,
  };
};


const {
  addMessageBoxError,
  getInvoicesListDownload,
  clearInvoicesListDownload,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  getInvoicesListDownload,
  clearInvoicesListDownload,
  navigateTo,
})(InvoicesList);
